<template>
  <svg
    width="8"
    height="16"
    viewBox="0 0 8 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.54062 2.65625H8V0.1125C7.74687 0.078125 6.88125 0 5.87187 0C3.76562 0 2.32188 1.325 2.32188 3.75938V6H0V8.84375H2.325V16H5.175V8.84375H7.40625L7.75937 6H5.175V4.04063C5.17188 3.21875 5.39375 2.65625 6.54062 2.65625Z"
      fill="white"
    />
  </svg>
</template>
  
<script>
export default {
  name: "FacebookWhiteIcon",
};
</script>